// Import polyfills FIRST - they will be transpiled by Vite legacy plugin
import "./polyfills";

import { bootWhenConfigured } from "@t-soft-io/retail-shared/brand";
import { loadAppConfiguration } from "./config/get-config";

bootWhenConfigured({
  rootElement: document.getElementById("root") as HTMLElement,
  load: () => loadAppConfiguration(),
  importApp: () => import("./bootstrap/app"),
  failureMessage: "This terminal could not be configured. Please try again later.",
});
